var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPulIkonu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 449.45 384.38",
    style: {
      enableBackground: "new 0 0 449.45 384.38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6F52EA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.42,329.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.42,260.12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.63,220.09L361.01,9.19c-1.5-3.87-5.86-5.77-9.72-4.25L9.74,138.73c-3.03,1.19-4.87,4.13-4.76,7.2 c0.08-4.17,3.47-7.5,7.67-7.5h42.81L348.34,23.71l76.13,194.33l-37.66,14.75v17.63l52.58-20.6 C443.25,228.31,445.15,223.94,443.63,220.09z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.62,92.07c-0.92-2.32-3.54-3.49-5.88-2.57c-21.17,8.3-45.07-2.15-53.37-23.32 c-0.38-0.97-1.3-1.54-2.28-1.54c-0.29,0-0.6,0.05-0.89,0.16l-187.96,73.63h44.97l137.58-53.89 c12.69,17.85,34.72,27.07,56.44,23.42l11.93,30.47h17.62L355.62,92.07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.31,138.8H12.48c-4.14,0-7.5,3.36-7.5,7.5v226.52c0,4.14,3.36,7.5,7.5,7.5h366.82 c4.14,0,7.5-3.36,7.5-7.5V146.3C386.81,142.16,383.45,138.8,379.31,138.8z M369.71,363.92H22.09V155.2h347.62V363.92z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.48,206.51c-29.3,0-53.05,23.75-53.05,53.05c0,29.3,23.75,53.05,53.05,53.05 c29.3,0,53.05-23.75,53.05-53.05C249.53,230.26,225.78,206.51,196.48,206.51z M196.48,294c-19.02,0-34.44-15.42-34.44-34.44 c0-19.02,15.42-34.44,34.44-34.44c19.02,0,34.44,15.42,34.44,34.44C230.91,278.58,215.5,294,196.48,294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.34,245.6c-7.71,0-13.96,6.25-13.96,13.96c0,7.71,6.25,13.96,13.96,13.96c7.71,0,13.96-6.25,13.96-13.96 C306.3,251.85,300.05,245.6,292.34,245.6z M292.34,263.75c-2.31,0-4.19-1.88-4.19-4.19s1.88-4.19,4.19-4.19 c2.31,0,4.19,1.88,4.19,4.19S294.66,263.75,292.34,263.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.31,245.6c-7.71,0-13.96,6.25-13.96,13.96c0,7.71,6.25,13.96,13.96,13.96c7.71,0,13.96-6.25,13.96-13.96 C115.27,251.85,109.02,245.6,101.31,245.6z M101.31,263.75c-2.31,0-4.19-1.88-4.19-4.19s1.88-4.19,4.19-4.19 c2.31,0,4.19,1.88,4.19,4.19S103.62,263.75,101.31,263.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.02,216.98L347.02,216.98c-22.75,0-41.18-18.44-41.18-41.18v0c0-1.35-1.09-2.44-2.44-2.44H84.73 c-0.48,0-0.87,0.39-0.87,0.87v0c-0.09,22.68-18.51,41.01-41.18,41.01h0c-1.35,0-2.44,1.09-2.44,2.44v84.47 c0,1.35,1.09,2.44,2.44,2.44c22.75,0,41.18,18.44,41.18,41.18h219.88c1.16,0,2.09-0.94,2.09-2.09 c0-22.75,18.44-41.18,41.18-41.18h0c2.51,0,4.54-2.03,4.54-4.54v-76.44C351.56,219.01,349.53,216.98,347.02,216.98z  M335.16,287.31c-21.43,4.51-38.51,20.96-43.92,42.05H97.88c-5.77-19.4-21.51-34.54-41.25-39.47v-59.97 c19.95-5,35.83-20.45,41.44-40.17h193.07c5.31,21.25,22.46,37.87,44.01,42.4V287.31z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulIkonu);
export default __webpack_public_path__ + "static/media/Pul-ikonu.8ed5f0c4f019807907873ce8283f172a.svg";
export { ForwardRef as ReactComponent };